// extracted by mini-css-extract-plugin
export var wrapper = "f_b";
export var box = "f_L";
export var cta = "f_M";
export var actions = "f_N";
export var headerWrapper = "f_P";
export var header = "f_Q";
export var fixed = "f_R";